import React from 'react'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'

// router
import { withRouter } from 'react-router-dom'

const ItemEtiqueta = ({ item, onRemove }) => {
    return (
        <tr>
            <th scope="row">{item.codigo}</th>
            <td>{item.nombre}</td>
            <td>{item.codigoBarra || '-'}</td>
            <td>{Number(item.precio).toFixed(2)}</td>
            <td>
                <button
                    type="button"
                    className="btn text-danger"
                    onClick={() => onRemove(item)}
                    title="Quitar"
                >
                    <FontAwesomeIcon icon={faTrash} />
                </button>
            </td>
        </tr>
    )
}

export default withRouter(ItemEtiqueta)
